import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "@i18n";
import Layout from "@/_LayoutsRelated/layout/Layout";
import Loader from "@componentsShared/Loader/Loader";
import TrackingLandingHeader from "../trackingLanding/TrackingLandingHeader";
import useApi from "@hooks/useApi";
import useHelpers from "@hooks/useHelpers";
import { api__getCouponOrderDetails } from "@/apis/orderTracking/api__getCouponOrderDetails";
import useIsMobile from "@hooks/useIsMobile";
import useWebView from "@hooks/useWebview";
import BreadCrumb from "@componentsShared/BreadCrumb";
import CouponQrModal from "./CouponQrModal";
import { trackEvents } from "@/common/events/events";
import { twMerge } from "tailwind-merge";
import { Icon } from "@syarahtech/ui";
var isCouponActive = function isCouponActive(coupon) {
  return coupon.status_badge.status == "available" || coupon.status_badge.status == "in_use";
};

/* ---------- Badge (from API) ---------- */
var ServiceBadge = function ServiceBadge(_ref) {
  var badge = _ref.badge;
  return /*#__PURE__*/React.createElement("div", {
    className: "inline-flex items-center gap-1 rounded-[12px] ps-2 pe-3 py-0.5 text-xs font-bold leading-4 whitespace-nowrap",
    style: {
      backgroundColor: badge.text_background,
      color: badge.text_color
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: badge.icon,
    alt: "",
    className: "w-4 h-4 shrink-0"
  }), /*#__PURE__*/React.createElement("span", null, badge.text));
};

/* ---------- Info card ---------- */
var InfoCard = function InfoCard(_ref2) {
  var data = _ref2.data;
  var webview = useWebView();
  var handleDownload = function handleDownload(e) {
    e.preventDefault();
    if (!data.pdf_download_url) return;
    webview.openFile(data.pdf_download_url)["catch"](function () {
      document.location = "/download?url=".concat(encodeURIComponent(data.pdf_download_url));
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white border border-solid border-[#e6e9ef] rounded-lg p-4 lg:p-6 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08)] w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4  w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 items-center justify-end w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shrink-0 w-[90px] h-[68px] lg:w-[120px] lg:h-[90px] rounded-lg overflow-hidden bg-[#f2f2f2]"
  }, /*#__PURE__*/React.createElement("img", {
    src: data.product_image,
    alt: data.title,
    className: "w-full h-full object-cover"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-0 flex flex-col gap-2 lg:gap-3 items-start"
  }, /*#__PURE__*/React.createElement(ServiceBadge, {
    badge: data.badge
  }), /*#__PURE__*/React.createElement("h1", {
    className: "text-xl lg:text-lg font-bold leading-7 text-[#00143c] text-start w-full"
  }, data.title))), /*#__PURE__*/React.createElement("p", {
    className: "text-sm lg:text-base font-medium lg:font-normal leading-5 lg:leading-6 text-[#6b7ea5] text-start w-full"
  }, data.description)), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center justify-center size-8 rounded-[7px] bg-[#f1f6fc] text-[#6b7ea5]"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "text-[#6B7EA5]",
    icon: "material-symbols--calendar-today-outline-rounded"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-xs leading-4 text-[#6b7ea5] whitespace-nowrap"
  }, data.created_at_formatted)), (data === null || data === void 0 ? void 0 : data.cta_label) && /*#__PURE__*/React.createElement("a", {
    href: data.pdf_download_url,
    onClick: handleDownload,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "md:w-[65%] w-full md:my-2 mx-auto flex items-center justify-center gap-1 rounded px-3 py-2 md:py-3 text-sm font-bold leading-6",
    style: {
      backgroundColor: data.cta_background_color,
      color: data.cta_text_color
    }
  }, data.cta_label, /*#__PURE__*/React.createElement("img", {
    src: data.cta_icon,
    alt: "",
    className: "w-5 h-5"
  }))));
};

/* ---------- Coupon card ---------- */
var CouponCard = function CouponCard(_ref3) {
  var coupon = _ref3.coupon,
    pdfDownloadUrl = _ref3.pdfDownloadUrl,
    tShort = _ref3.tShort;
  var isActive = isCouponActive(coupon);
  var canShowQr = coupon.status_badge.status == "available";
  var _useState = useState(false),
    qrOpen = _useState[0],
    setQrOpen = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return canShowQr && !qrOpen && setQrOpen(true);
    },
    role: canShowQr ? "button" : undefined,
    className: twMerge("bg-white border border-solid border-[#e6e9ef] rounded-lg px-4 py-[13px] flex gap-3 items-center justify-end w-full", canShowQr && "cursor-pointer")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-0 flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 items-center "
  }, /*#__PURE__*/React.createElement("span", {
    className: "rounded-lg px-3 py-1 text-xs font-bold leading-4 whitespace-nowrap",
    style: {
      color: coupon.status_badge.status_color,
      backgroundColor: "".concat(coupon.status_badge.status_color, "1A")
    }
  }, coupon.status_badge.status_label), /*#__PURE__*/React.createElement("span", {
    className: "text-sm font-bold leading-5 text-[#6b7ea5] whitespace-nowrap"
  }, coupon.coupon_id)), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-4 items-center justify-end w-full"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-xl lg:text-2xl font-bold leading-7 lg:leading-8 whitespace-nowrap ".concat(!isActive ? "text-[#b0b0b0]" : "text-[#00143c]")
  }, coupon.qty_label), /*#__PURE__*/React.createElement("span", {
    className: "w-px h-[25px] shrink-0 bg-[#e6e9ef]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-0 flex flex-col gap-1 text-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-xs leading-4 text-[#6b7ea5] w-full"
  }, coupon.status_title), /*#__PURE__*/React.createElement("span", {
    className: "text-sm font-bold leading-5 w-full truncate ".concat(!isActive ? "text-[#b0b0b0]" : "text-[#00143c]")
  }, coupon.status_description)))), /*#__PURE__*/React.createElement("div", {
    className: twMerge("shrink-0 flex items-center justify-center size-12 rounded-[8px] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08)]", coupon.cta_bg && "bg-[".concat(coupon.cta_bg, "]"), coupon.status_badge.status == "available" && "cursor-pointer hover:bg-primary-new focus:bg-primary-new hover:text-white text-primary-new focus:text-white"),
    onClick: function onClick() {
      return coupon.status_badge.status == "available" && setQrOpen(true);
    }
  }, coupon.status_badge.status == "available" ? /*#__PURE__*/React.createElement(Icon, {
    icon: "mingcute--oil-fill",
    width: 4,
    height: 4
  }) : /*#__PURE__*/React.createElement("img", {
    src: coupon.cta_icon,
    alt: "",
    className: "w-4 h-4"
  }), " "), coupon.status_badge.status == "available" && qrOpen && /*#__PURE__*/React.createElement(CouponQrModal, {
    open: qrOpen,
    onClose: function onClose() {
      return setQrOpen(false);
    },
    coupon: coupon,
    pdfDownloadUrl: pdfDownloadUrl,
    tShort: tShort
  }));
};

/* ---------- Page ---------- */
var TrackingServiceDetails = function TrackingServiceDetails() {
  var _useTranslation = useTranslation(["web_tracking_finance", "web_tracking"]),
    tShort = _useTranslation.tShort;
  var _useParams = useParams(),
    id = _useParams.id;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    createUrl = _useHelpers.createUrl;
  var _useApi = useApi([id], function () {
      return api__getCouponOrderDetails(id);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    data = _useApi2[2];

  // order_tracking_viewed — landed on a specific (services) order page
  useEffect(function () {
    var _data$main_status;
    if (!data) return;
    trackEvents("order_tracking_viewed", {
      order_id: data.order_id,
      tracking_category: "services",
      order_type: "oil_coupon",
      order_step: (_data$main_status = data.main_status) === null || _data$main_status === void 0 ? void 0 : _data$main_status.status,
      has_warranty: "no"
    });
  }, [data === null || data === void 0 ? void 0 : data.order_id]);
  if (error) return navigateTo("/page404", {
    ref: "coupon-order-not-found"
  });
  if (loading || !data) return /*#__PURE__*/React.createElement(Loader, null);
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Layout, {
    linksForSearch: true,
    mobileHasTitle: tShort("coupon/order_details", {
      ns: "web_tracking"
    }),
    hideOrangeHeadBtn: true,
    mobileHasBack: true,
    mobileNoLogo: true,
    headHideLinks: true,
    hideFooter: true,
    hideHeaderOnmobile: true
  }, /*#__PURE__*/React.createElement(TrackingLandingHeader, {
    title: data.title,
    onBack: function onBack() {
      return window.history.go(-1);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "max-w-[1120px] mx-auto w-[92%] lg:w-full py-4 lg:py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block mb-6"
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    links: [{
      title: tShort("coupon/breadcrumb_root", {
        ns: "web_tracking"
      }),
      link: createUrl("/tracking-landing")
    }, {
      title: tShort("coupon/breadcrumb_services", {
        ns: "web_tracking"
      }),
      link: createUrl("/tracking-landing?tab=car_services")
    }, {
      title: data.title
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col lg:flex-row gap-4 lg:gap-6 items-start"
  }, isMobile && /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:flex-1"
  }, /*#__PURE__*/React.createElement(InfoCard, {
    data: data
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:flex-1 flex flex-col gap-4"
  }, data.coupons.map(function (coupon) {
    return /*#__PURE__*/React.createElement(CouponCard, {
      key: coupon.coupon_id,
      coupon: coupon,
      pdfDownloadUrl: data.pdf_download_url,
      tShort: tShort
    });
  })), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:flex-1"
  }, /*#__PURE__*/React.createElement(InfoCard, {
    data: data
  })))));
};
export default TrackingServiceDetails;